[
  {
    "id": "MET-B8-L301-001",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Reken om: 3.500 kg = ... ton",
    "options": [
      "3,5 ton",
      "35 ton",
      "0,35 ton",
      "350 ton"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-KG-TON",
    "explanation": "1 ton = 1.000 kg. 3.500 : 1.000 = 3,5 ton.",
    "distractorExplanations": {
      "1": "Je deelde door 100.",
      "2": "Je deelde door 10.000.",
      "3": "Je deelde door 10."
    }
  },
  {
    "id": "MET-B8-L301-002",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Hoeveel liter is 2,5 m³?",
    "options": [
      "2.500 liter",
      "250 liter",
      "25 liter",
      "25.000 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-M3-L-25",
    "explanation": "1 m³ = 1.000 liter. 2,5 × 1.000 = 2.500 liter.",
    "distractorExplanations": {
      "1": "Je deed ×100.",
      "2": "Je deed ×10.",
      "3": "Je deed ×10.000."
    }
  },
  {
    "id": "MET-B8-L301-003",
    "module": "Metriek",
    "difficulty": 301,
    "question": "De oppervlakte is 12 m². De breedte is 300 cm. Wat is de lengte?",
    "options": [
      "4 m",
      "40 m",
      "400 m",
      "0,4 m"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "oppervlakte",
    "subSkill": "oppervlakte",
    "familyId": "MET-OPP-TERUG-CM",
    "explanation": "300 cm = 3 m. 12 : 3 = 4 m.",
    "distractorExplanations": {
      "1": "Je hebt niet omgerekend naar meters.",
      "2": "Rekenfout.",
      "3": "Rekenfout."
    }
  },
  {
    "id": "MET-B8-L301-004",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Reken om: 450 mm = ... dm",
    "options": [
      "4,5 dm",
      "45 dm",
      "0,45 dm",
      "4.500 dm"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-MM-DM",
    "explanation": "Van mm naar dm is 2 stappen (delen door 100). 450 : 100 = 4,5 dm.",
    "distractorExplanations": {
      "1": "Je deelde door 10.",
      "2": "Je deelde door 1.000.",
      "3": "Je vermenigvuldigde met 10."
    }
  },
  {
    "id": "MET-B8-L301-005",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Hoeveel cm³ is 1 liter?",
    "options": [
      "1.000 cm³",
      "100 cm³",
      "10 cm³",
      "10.000 cm³"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-L-CM3",
    "explanation": "1 liter = 1 dm³ = 1.000 cm³.",
    "distractorExplanations": {
      "1": "Dat is 1 dl.",
      "2": "Dat is 1 cl.",
      "3": "Dat is 10 liter."
    }
  },
  {
    "id": "MET-B8-L301-006",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Een container is 12 m lang, 2,5 m breed en 3 m hoog. Hoeveel kubieke meter is de inhoud?",
    "options": [
      "90 m³",
      "17,5 m³",
      "36 m³",
      "900 m³"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-CONTAINER-B8",
    "explanation": "Inhoud = 12 × 2,5 × 3 = 90 m³.",
    "distractorExplanations": {
      "1": "Je telde de maten op.",
      "2": "Je deed 12 × 3 en vergat de breedte.",
      "3": "Je deed 90 × 10."
    }
  },
  {
    "id": "MET-B8-L301-007",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Reken om: 0,75 ton = ... gram",
    "options": [
      "750.000 g",
      "75.000 g",
      "7.500 g",
      "7.500.000 g"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-TON-G-B8",
    "explanation": "0,75 ton = 750 kg. 750 × 1.000 = 750.000 gram.",
    "distractorExplanations": {
      "1": "Je vergat de stap van kg naar gram.",
      "2": "Je deed 0,75 × 10.000.",
      "3": "Je deed 0,75 × 10.000.000."
    }
  },
  {
    "id": "MET-B8-L301-008",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Een bak is 2 m lang, 1,5 m breed en 0,8 m hoog. Hoeveel liter past erin?",
    "options": [
      "2.400 liter",
      "240 liter",
      "24.000 liter",
      "4,3 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-BAK-B8",
    "explanation": "Inhoud = 2 × 1,5 × 0,8 = 2,4 m³. 2,4 × 1.000 = 2.400 liter.",
    "distractorExplanations": {
      "1": "Je vergat ×1.000 om naar liter te gaan.",
      "2": "Je deed ×10.000.",
      "3": "Je telde de maten op."
    }
  },
  {
    "id": "MET-B8-L301-009",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Reken om: 3,6 dm³ = ... liter",
    "options": [
      "3,6 liter",
      "36 liter",
      "0,36 liter",
      "360 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-DM3-L-B8",
    "explanation": "1 dm³ = 1 liter. Dus 3,6 dm³ = 3,6 liter.",
    "distractorExplanations": {
      "1": "Je deed ×10.",
      "2": "Je deed ÷10.",
      "3": "Je deed ×100."
    }
  },
  {
    "id": "MET-B8-L301-010",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Een kamer is 5 m lang, 4 m breed en 2,8 m hoog. Hoeveel kubieke meter lucht zit erin?",
    "options": [
      "56 m³",
      "11,8 m³",
      "20 m³",
      "560 m³"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-KAMER-B8",
    "explanation": "Inhoud = 5 × 4 × 2,8 = 56 m³.",
    "distractorExplanations": {
      "1": "Je telde de maten op.",
      "2": "Je deed 5 × 4 en vergat de hoogte.",
      "3": "Je deed 56 × 10."
    }
  },
  {
    "id": "MET-B8-L301-011",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Hoeveel ml is 0,035 liter?",
    "options": [
      "35 ml",
      "3,5 ml",
      "350 ml",
      "0,35 ml"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-L-ML-B8",
    "explanation": "1 liter = 1.000 ml. 0,035 × 1.000 = 35 ml.",
    "distractorExplanations": {
      "1": "Je deed ×100.",
      "2": "Je deed ×10.000.",
      "3": "Je deed ×10."
    }
  },
  {
    "id": "MET-B8-L301-012",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Reken om: 2.800 kg = ... ton",
    "options": [
      "2,8 ton",
      "28 ton",
      "0,28 ton",
      "280 ton"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-KG-TON-2",
    "explanation": "1 ton = 1.000 kg. 2.800 : 1.000 = 2,8 ton.",
    "distractorExplanations": {
      "1": "Je deelde door 100.",
      "2": "Je deelde door 10.000.",
      "3": "Je deelde door 10."
    }
  },
  {
    "id": "MET-B8-L301-013",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Een aquarium is 100 cm lang, 40 cm breed en 50 cm hoog. Hoeveel liter past erin?",
    "options": [
      "200 liter",
      "20 liter",
      "2.000 liter",
      "190 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-AQUARIUM-B8",
    "explanation": "Inhoud: 100 × 40 × 50 = 200.000 cm³. 200.000 : 1.000 = 200 liter.",
    "distractorExplanations": {
      "1": "Je deelde door 10.000.",
      "2": "Je vergat te delen door 1.000.",
      "3": "Je maakte een rekenfout."
    }
  },
  {
    "id": "MET-B8-L301-014",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Hoeveel hectoliter (hl) is 500 liter?",
    "options": [
      "5 hl",
      "50 hl",
      "0,5 hl",
      "500 hl"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-L-HL",
    "explanation": "1 hl = 100 liter. 500 : 100 = 5 hl.",
    "distractorExplanations": {
      "1": "Je deelde door 10.",
      "2": "Je deelde door 1.000.",
      "3": "Je deelde niet."
    }
  },
  {
    "id": "MET-B8-L301-015",
    "module": "Metriek",
    "difficulty": 301,
    "question": "Een doos is 30 cm lang, 20 cm breed en 15 cm hoog. Hoeveel liter past erin?",
    "options": [
      "9 liter",
      "0,9 liter",
      "90 liter",
      "65 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-DOOS-B8",
    "explanation": "Inhoud: 30 × 20 × 15 = 9.000 cm³. 9.000 : 1.000 = 9 liter.",
    "distractorExplanations": {
      "1": "Je deelde door 10.000.",
      "2": "Je vergat te delen door 1.000.",
      "3": "Je telde de maten op."
    }
  }
]